<mode-user-email
  *ngFor="let user of subscribers"
  class="email-subscriber"
  [avatar]="user.avatar"
  [email]="user.email"
  [isExternalDomain]="isExternalDomain(user.email) && !user.inWorkspace"
  [externalSharingEnabled]="externalSharingEnabled"
  [showCloseBtn]="true"
  (closeBtnClicked)="removeMember.emit(user)"
  data-test="email-subscriber-list"
></mode-user-email>
